import React, { Component } from 'react'

import { mop } from "../static/svg/mop"

class StarRaters extends Component {
	state = {
		highlighted: -1
	}
	handleStarClick = value => {
		if(!this.props.disabled){ this.props.onChange(value) }
	}
	handleHighlight = grade => {
		this.setState({ highlighted: grade })
	}
	removeHighlight = e => {
		this.setState({ highlighted: -1 })
	}
	render() {
		let { value, disabled } = this.props
		let { highlighted } = this.state
		return(
			<div className={"StarRaters " + (disabled ? "disabled" : "")}>
				{Array(5).fill(0).map((e, i) =>
					<div
						key={i} className={"mop " + (value >= i + 1 ? "active" : "" ) + (i <= highlighted ? " highlighted" : "")}
						onMouseEnter={this.handleHighlight.bind(this, i)}
						onMouseLeave={this.removeHighlight}
						onClick={this.handleStarClick.bind(this, i + 1)}
					>
							{mop}
					</div>
				)}
			</div>
		)
	}
}

StarRaters.defaultProps = {
	onChange: () => {},
	disabled: false
}

export default StarRaters



// WEBPACK FOOTER //
// ./src/components/StarRaters.js